import { useEffect, useState } from "react";
import type { ValidationRules } from "features/languages/types";
import { languagesService } from "features/languages/services/languages-services";

export const useFetchValidationRules = () => {
  const [validationRules, setValidationRules] = useState<ValidationRules>();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      setIsFetching(true);

      try {
        const response = await languagesService.getGetValidationRules(abortController);

        setValidationRules(response);
      } catch (error) {
        console.error(error);
      }

      setIsFetching(false);
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return [validationRules, isFetching];
};
